// actions/homeworkActions.js
import createApi from "../utils/apiClient";
const api = createApi();

export const getHomework = (params) => async (dispatch) => {
  try {
    dispatch({ type: "HOMEWORK_REQUEST" });
    const { data } = await api.get("/homework", { params });
    dispatch({ type: "GET_HOMEWORK_SUCCESS", payload: data.homework });
  } catch (err) {
    dispatch({ type: "HOMEWORK_FAIL", payload: err.response?.data?.message });
  }
};

export const markHomeworkViewed = (hwId, studentId) => async () => {
  try {
    await api.post(`/homework/${hwId}/view`, { student_id: studentId });
  } catch {
    // Non-critical — a failed view-ping shouldn't disrupt the student's
    // experience or throw a visible error.
  }
};

export const createHomework = (hwData) => async (dispatch) => {
  try {
    dispatch({ type: "HOMEWORK_REQUEST" });
    const { data } = await api.post("/homework", hwData);
    dispatch({ type: "CREATE_HOMEWORK_SUCCESS", payload: data.homework });
  } catch (err) {
    dispatch({ type: "HOMEWORK_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const submitHomework = (hwId, payload) => async (dispatch) => {
  try {
    dispatch({ type: "HOMEWORK_REQUEST" });
    const { data } = await api.post(`/homework/${hwId}/submit`, payload);
    dispatch({
      type: "SUBMIT_HOMEWORK_SUCCESS",
      payload: { hwId, submission: data.submission },
    });
    return data.submission;
  } catch (err) {
    dispatch({ type: "HOMEWORK_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const reviewSubmission = (subId, payload) => async (dispatch) => {
  try {
    const { data } = await api.patch(`/homework/submissions/${subId}`, payload);
    dispatch({
      type: "REVIEW_SUBMISSION_SUCCESS",
      payload: data.submission,
    });
    return data.submission;
  } catch (err) {
    dispatch({ type: "HOMEWORK_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};

export const deleteSubmission =
  (subId, hwId, studentId) => async (dispatch) => {
    try {
      await api.delete(`/homework/submissions/${subId}`);
      dispatch({
        type: "DELETE_SUBMISSION_SUCCESS",
        payload: { hwId, studentId },
      });
    } catch (err) {
      dispatch({ type: "HOMEWORK_FAIL", payload: err.response?.data?.message });
      throw err;
    }
  };

export const deleteHomework = (hwId) => async (dispatch) => {
  try {
    await api.delete(`/homework/${hwId}`);
    dispatch({ type: "DELETE_HOMEWORK_SUCCESS", payload: hwId });
  } catch (err) {
    dispatch({ type: "HOMEWORK_FAIL", payload: err.response?.data?.message });
    throw err;
  }
};
